angular.module('unica_feedback_category.feedback_category_controllers')

.controller('FeedbackCategoryListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	FeedbackCategoryListService, FeedbackCategoryDeleteService
) {
	$scope.categories = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.loadCategories = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		FeedbackCategoryListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();
				if ( data && !data.error) {
					$scope.categories = $scope.categories.concat( data );
					if ( data.length === 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadCategories();

	$scope.deleteFeedbackCategory = function(feedbackCategoryId) {
		$confirm({
			title: 'Sei sicuro di voler eliminare la categoria?',
			text: 'Confermi la cancellazione della categoria?'
		}).then(function() {

			$scope.showLoader();
			FeedbackCategoryDeleteService
				.delete( feedbackCategoryId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.categories, function(category, key) {
							if ( category.id === feedbackCategoryId ) {
								$scope.categories.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Categoria eliminata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.downloadExportFeedbackCategories = false;
	$scope.exportFeedbackCategoriesUrl      = '';

	$scope.prepareFeedbackCategoriesExportUrl = function()
	{
		$scope.showLoader();
		FeedbackCategoryListService
			.exportFeedback( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportFeedbackCategories = true;
					$scope.exportFeedbackCategoriesUrl      = url;
				}
			});
	};

})

;